import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DragDropFileComponent } from '../drag-drop-file/drag-drop-file.component';

@Component({
  selector: 'app-upload-file-xls',
  templateUrl: './upload-file-xls.component.html',
  styleUrls: ['./upload-file-xls.component.scss']
})
export class UploadFileXlsComponent {
  @ViewChild('dragDrop') dragDrop: DragDropFileComponent;
  @Output() OnFileChanged: EventEmitter<File> = new EventEmitter<File>();
  @Output() OnClickDownloadTemplate: EventEmitter<unknown> = new EventEmitter<unknown>();
  public reset() {
    this.dragDrop.reset();
  }
  fileChange(file: File) {
    this.OnFileChanged.emit(file);
  }

  downloadTemplate() {
    this.OnClickDownloadTemplate.emit();
  }
}
